import React from "react";
import { FormattedMessage } from "react-intl";

import { Pressable } from "../pressable";
import { Image } from "../image";
import { useSendCommand } from "../../hooks/use-send-command";
import { OPEN_LINK } from "../../constants/types/commands";

import styles from "./styles.modules.scss";

export const ContentfulSocialLinks = ({
    links,
    titleLabel = "globalText.langFollowUs",
    showBanner = false,
}: {
    links?: SocialLink[];
    showBanner?: boolean;
    titleLabel?: string;
}) => {
    const sendCommand = useSendCommand();

    if (!links) {
        return null;
    }

    const linksIsEmpty = Object.keys(links).length === 0;

    if (linksIsEmpty) {
        return null;
    }

    const onClick = (url: string) => sendCommand(OPEN_LINK, { url });

    return (
        <div className={`contentful-social-links ${styles.socialLinks}`}>
            <div className={`title ${styles.title}`}>
                <FormattedMessage id={titleLabel} />
            </div>

            <div
                className={`contentful-social-links-wrapper ${styles.socialLinksWrapper}`}
            >
                {links.map((l) => {
                    const { linkUrl, socialLinkImage } = l;

                    const inner = (
                        <Pressable>
                            <div
                                className={`contentful-social-link ${styles.socialLink}`}
                            >
                                <Image sources={socialLinkImage} />
                            </div>
                        </Pressable>
                    );

                    return (
                        <div
                            className={`contentful-press ${styles.press}`}
                            key={`link_${
                                linkUrl ?? socialLinkImage.small.path
                            }`}
                            onClick={() => onClick(linkUrl ?? "")}
                        >
                            {inner}
                        </div>
                    );
                })}

                {showBanner && <div className={`banner ${styles.banner}`} />}
            </div>
        </div>
    );
};
